import { render, staticRenderFns } from "./ADpageWithWxForm2.vue?vue&type=template&id=71851c11&scoped=true&"
import script from "./ADpageWithWxForm2.vue?vue&type=script&lang=tsx&"
export * from "./ADpageWithWxForm2.vue?vue&type=script&lang=tsx&"
import style0 from "./ADpageWithWxForm2.vue?vue&type=style&index=0&id=71851c11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71851c11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71851c11')) {
      api.createRecord('71851c11', component.options)
    } else {
      api.reload('71851c11', component.options)
    }
    module.hot.accept("./ADpageWithWxForm2.vue?vue&type=template&id=71851c11&scoped=true&", function () {
      api.rerender('71851c11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingADpages/ADpageWithWxForm2.vue"
export default component.exports